import React from 'react'
import ReactDOM from 'react-dom' //react-dom/client
import './custom.css'
import App from './App'
import store from './store/store'
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux'
//import { version } from './features/version/version';

//store.dispatch(version())

//ReactDOM.createRoot(document.getElementById('root')).render(
ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
)

registerServiceWorker();